import { dgSegregationRulesApi, DGSegregationRuleDto } from '@yard/app/api/dg-config-api'

export class DGSegregationRuleDataStore {
  async getAll(): Promise<DGSegregationRuleDto[]> {
    return dgSegregationRulesApi.getAll()
  }

  async upsertBulk(
    rules: Array<{ imoClass1: string; imoClass2: string; distance: number; isProhibited: boolean }>,
  ): Promise<DGSegregationRuleDto[]> {
    return dgSegregationRulesApi.upsert({ rules })
  }

  async resetToDefaults(): Promise<DGSegregationRuleDto[]> {
    return dgSegregationRulesApi.resetToDefaults()
  }
}
